import { buildR2AssetsImageUrl } from "@saas/shared/lib/image-url-builder";
import type { FlyingCarQualityId } from "./flying-car-preset";

export interface FlyingCarShowcaseClip {
	id: string;
	/** 本页两种效果：工作台各自的 Examples 按它分，下面样片区两种都放 */
	effect: "ramp" | "fly";
	quality: FlyingCarQualityId;
	orientation: "portrait";
	onSite: boolean;
	duration: number;
	videoUrl: string;
	previewVideoUrl: string;
	poster: string;
	/** 卡头方图（effects-catalog 取第一条的） */
	icon?: string;
	hasAudio: boolean;
	inputImages: string[];
	/** Fly 有四个场景，Try 时先切到出这条用的那个；Ramp 只有一个模板，不用填 */
	templateId?: string;
}

const R2_BASE = "home/showcase/flying-car-ai";
/** 2026-10-28 换官方片 v2 后重出，换文件名：旧文件在 CDN 有缓存，推之前线上还在用 */
const CLIP_VERSION = "v2";
/**
 * 本页工作台 Standard 坡道翻车实片，三张车照各一条；橙色轿跑排第一，工作台 Ramp 的 Examples 只放它。
 * 三蹦子 10/28 老公定从工作台和样片区撤下（文件还在桶里）。来源与参数见 packages/scripts/flying-car-showcase/README.md。
 */
const SPECS: {
	id: string;
	quality: FlyingCarQualityId;
	ref: string;
	duration: number;
	/** 单条重出时换文件名，不跟着动其它几条 */
	version?: string;
	/** posters/ 下的方图文件名；poster 9:16 中间是黑天，卡头和 4:3 卡片裁出来一团黑 */
	icon?: string;
}[] = [
	{
		id: "standard-ramp",
		quality: "standard",
		ref: "car-1",
		duration: 15.104,
		/** 10.3 秒橙车悬在烟上，400×400 */
		icon: "standard-ramp-v2-icon",
	},
	{
		id: "sedan-ramp",
		quality: "standard",
		ref: "car-2",
		duration: 15.104,
	},
	{
		id: "pickup-ramp",
		quality: "standard",
		ref: "car-3",
		duration: 15.104,
	},
];
export const flyingCarShowcaseClips: FlyingCarShowcaseClip[] = [
	...SPECS.map(
		(clip): FlyingCarShowcaseClip => ({
			id: clip.id,
			effect: "ramp",
			quality: clip.quality,
			orientation: "portrait",
			onSite: true,
			duration: clip.duration,
			videoUrl: buildR2AssetsImageUrl(
				`${R2_BASE}/clips/${clip.id}-${clip.version ?? CLIP_VERSION}-720p.mp4`,
			),
			previewVideoUrl: buildR2AssetsImageUrl(
				`${R2_BASE}/clips/${clip.id}-${clip.version ?? CLIP_VERSION}-720p.mp4`,
			),
			poster: buildR2AssetsImageUrl(
				`${R2_BASE}/posters/${clip.id}-${clip.version ?? CLIP_VERSION}-720p.jpg`,
			),
			...(clip.icon && {
				icon: buildR2AssetsImageUrl(
					`${R2_BASE}/posters/${clip.icon}.jpg`,
				),
			}),
			hasAudio: true,
			inputImages: [
				buildR2AssetsImageUrl(`${R2_BASE}/refs/${clip.ref}.jpg`),
			],
		}),
	),
	/**
	 * Make My Car Fly：10/28 选模型时 Lite（Mini 480p）出的那条，老公定直接用。脚本直连 KIE、
	 * prompt 和页面模板一字不差，不是从本站页面提交的。来源见 README「Make My Car Fly 示例」
	 */
	{
		id: "fly-coastal",
		effect: "fly",
		templateId: "coastal",
		quality: "lite",
		orientation: "portrait",
		onSite: true,
		duration: 10.08,
		videoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/fly-coastal-v1-480p.mp4`,
		),
		previewVideoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/fly-coastal-v1-480p.mp4`,
		),
		poster: buildR2AssetsImageUrl(
			`${R2_BASE}/posters/fly-coastal-v1-480p.jpg`,
		),
		hasAudio: true,
		inputImages: [
			buildR2AssetsImageUrl(`${R2_BASE}/refs/fly-person-1.jpg`),
			buildR2AssetsImageUrl(`${R2_BASE}/refs/car-1.jpg`),
		],
	},
];
export const FLYING_CAR_SHOWCASE_UPLOADED_AT = "2026-10-28T11:12:00+08:00";
